import { SafeEnv } from 'SharedDir/utils/helpers';
import { App } from 'vue';

/**
 *
 * @param {App} app
 */
export function provideCommonServices(app) {
  app.provide('YANDEX_API_KEY', SafeEnv(() => process.env.YANDEX_API_KEY));
  app.provide('DADATA_API_KEY', SafeEnv(() => process.env.DADATA_API_KEY));
  app.provide('YANDEX_CAPTCHA_API_KEY', SafeEnv(() => process.env.YANDEX_CAPTCHA_API_KEY));
}
